module.exports = __webpack_public_path__ + "static/media/bonus-icon.1aae9c6d.svg";